import { IOffer } from '@rbi-ctg/menu';
import { IListOffersByUserIdQuery } from 'generated/rbi-graphql';
import { IOffersFragment } from 'generated/sanity-graphql';

/**
 * make an object like this to help with lookups later
 * {
 *  couponId1: 2,
 *  couponId4: 5
 * }
 */
export const countAvailableOffersByCouponId = (
  offers: IListOffersByUserIdQuery
): { [key: string]: number } | undefined =>
  offers.listUserCouponTokens?.tokens?.reduce((coupons, nextCoupon) => {
    if (nextCoupon?.couponId) {
      const thisCouponCount = coupons[nextCoupon.couponId];
      return {
        ...coupons,
        [nextCoupon.couponId]: Number.isInteger(thisCouponCount) ? thisCouponCount + 1 : 1,
      };
    }
    return coupons;
  }, {});

export const combineSortedOffersWithAvailableOfferCounts = (
  sortedOffers: IOffersFragment[],
  offerCountByCouponId: { [key: string]: number }
) =>
  sortedOffers.map(offer => {
    return {
      ...offer,
      numberAvailable: offer?._id ? offerCountByCouponId[offer?._id] : 1,
    } as IOffer;
  });
